<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>For MBP review</h4>
        <p class="pse-muted">
          The new enquiry screens, on TEST for you to try. The New Enquiry form comes in two layouts: please try both and
          tell us which one you prefer. Until then, the layout set in Shared Enquiry Settings is the one every "New Enquiry"
          and "New Quotation" button opens.
        </p>
        <div class="p-grid">
          <div v-for="item in items" :key="item.label" class="p-col-12 p-md-6 p-lg-4">
            <div class="pse-review-item">
              <h5><i :class="item.icon"></i> {{ item.label }}</h5>
              <p>{{ item.text }}</p>
              <Button :label="item.button" icon="pi pi-arrow-right" iconPos="right" class="p-button-outlined" style="width: auto;"
                @click="$router.push(item.to).catch(() => {})" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REVIEW_ITEMS } from './mbpReviewItems'

// The "For MBP review" landing page (Mohammed 20/10): one card per thing to try, with a line saying what it shows.
export default {
  name: 'MbpReview',
  data() {
    return { items: REVIEW_ITEMS }
  }
}
</script>

<style scoped>
@import './sharedEnquiry.css';
.pse-review-item { border: 1px solid #dee2e6; border-radius: 6px; padding: 14px 16px; height: 100%; }
.pse-review-item h5 { margin: 0 0 6px; }
.pse-review-item p { color: #495057; min-height: 60px; }
</style>
